import { createAsyncThunk } from '@reduxjs/toolkit';
import { changeCurrentMemories, setAnon, setAnonModifierIndex } from './threadsUiSlice';
import { navigateTo } from './navigationActions';

const openAndCloseAnonModule =
  (open: boolean) =>
  async ({ history }: { history }, { dispatch, getState }) => {
    const { moduleIndex, modifierIndex } = getState().threadUi;

    dispatch(changeCurrentMemories({ moduleIndex, modifierIndex: modifierIndex !== undefined ? modifierIndex : -1 }));
    dispatch(setAnonModifierIndex(null));
    dispatch(setAnon(open));

    dispatch(navigateTo({ history }));
  };

export const openAnonModule = createAsyncThunk('threadUi/openAnonModule', openAndCloseAnonModule(true));
export const closeAnonModule = createAsyncThunk('threadUi/closeAnonModule', openAndCloseAnonModule(false));
